import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from 'sagas';
import appReducer from './app';
import backendReducer from './backend';
import backyardReducer from './backyard';
import flashMessageReducer from './flashMessage';
import surveyReducer from './survey';

const sagaMiddleware = createSagaMiddleware();

interface ExtendedWindow extends Window {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
}
declare let window: ExtendedWindow;

const composeReduxDevToolsEnhancers =
  (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
  combineReducers({
    app: appReducer,
    flashMessage: flashMessageReducer,
    survey: surveyReducer,
    backend: backendReducer,
    backyard: backyardReducer,
  }),
  composeReduxDevToolsEnhancers(applyMiddleware(sagaMiddleware)),
);

sagaMiddleware.run(rootSaga);

export default store;
